var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-overview" },
    [
      _vm.showKycVerifyBanner === 1 || _vm.showKycVerifyBanner === 4
        ? _c(
            "div",
            { staticClass: "kyc-verify-banner" },
            [
              _c("div", { staticClass: "kyc-verify-banner-content" }, [
                _c("div", { staticClass: "kyc-verify-banner-title" }, [
                  _c("i", {
                    staticClass: "el-icon-warning",
                    staticStyle: { color: "#FFA900" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("kyc.dashboard_kyc_title"))),
                ]),
                _c("div", { staticClass: "kyc-verify-banner-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.dashboard_kyc_subtitle"))),
                ]),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "kyc-verify-banner-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.goToKyc },
                },
                [_vm._v(_vm._s(_vm.$t("kyc.dashboard_kyc_btn_text")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.$store.getters.isAllCountry
        ? _c("MyBalanceAndExchangeRate")
        : _c("BalancePanel"),
      _c("TotalTransactionDataPannel", {
        on: {
          changeShowType: _vm.changeShowType,
          "currency-change": _vm.handleCurrencyChange,
        },
      }),
      _c("div", { staticClass: "data-container" }, [
        _c(
          "div",
          { staticClass: "data-container-title" },
          [
            _vm._v(" " + _vm._s(_vm.$t("dashboard.transaction_trends")) + " "),
            _vm.$store.getters.isPii
              ? _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("tips.current_time_zone"))),
                    ]),
                  ]),
                  _c(
                    "span",
                    [
                      _c("svg-icon", {
                        staticStyle: {
                          width: "22px",
                          color: "#3855F1",
                          cursor: "pointer",
                        },
                        attrs: { "icon-class": "icon-font-warning" },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "data-container-search" },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("components.date")) + ":")]),
            _c(
              "el-select",
              {
                staticClass: "search-frame mb-10",
                attrs: { size: "small", clearable: "" },
                on: { change: _vm.onClickchangeTimes },
                model: {
                  value: _vm.activeColor,
                  callback: function ($$v) {
                    _vm.activeColor = $$v
                  },
                  expression: "activeColor",
                },
              },
              _vm._l(_vm.dateArr, function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "search-frame  mb-10",
                attrs: { size: "small", clearable: "" },
                model: {
                  value: _vm.showType,
                  callback: function ($$v) {
                    _vm.showType = $$v
                  },
                  expression: "showType",
                },
              },
              _vm._l(
                _vm.showTypeTransaction === "second"
                  ? _vm.transactionPayin
                  : _vm.transaction,
                function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }
              ),
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "search-btn mb-10",
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-search",
                },
                on: { click: _vm.getCharData },
              },
              [_vm._v(_vm._s(_vm.$t("components.search")))]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "bar-container" },
        [
          _c("bar-chart", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { "char-data": _vm.charData },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }